<!-- 融资申请第四步 -->
<template>
  <section class="step4-form"  :style="{minHeight:(screenHeight-85)+'px'}">
    <div v-if="this.$route.query.yanse == 1"  class="step-form__step-num2" >4/5</div>
    <div v-if="this.$route.query.yanse == 2" class="step-form__step-num" >4/5</div>
    <div class="step-form__main">
      <h1 class="step-form__title">{{this.$route.query.productName}}-资料附件确认</h1>
      <div class="step-form__file-list file-list" v-for="(item, index) in fileTypeLists.itemFiles">
        <h6 class="file-list__item-title"><span>{{`${item.name}${item.isMustUpload === '1' ? '（必传）' : ''}`}}</span></h6>
        <div class="file-list__item-content">
          <ul class="file-list__item-list">
            <template v-for="file in fileLists.itemFiles[index].idsarr">
              <li v-if="/\.pdf|\.doc|\.docx|\.xls|\.xlsx|\.rar|\.zip|\.7z/g.test(file.fileName)"
                :class="['file-list__item-preview', `file-list__${file.fileName.substr(file.fileName.lastIndexOf('.')+1)}-preview`]"
                @click.self="showPreviewImage(file.fileId, false)">
                <div class="file-list__item-delete" @click="deleteUploadedFile(item.filesId, file)">
                  <i class="el-icon-close"></i>
                </div>
                <div class="file-list__file-name">{{file.fileName}}</div>
              </li>
              <li v-else class="file-list__item-preview">
                <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${userInfo.token}`" @click="showPreviewImage(file.fileId, true)">
                <div class="file-list__item-delete"
                     @click.stop="deleteUploadedFile(item.filesId, file)"><i class="el-icon-close"></i></div>
              </li>
            </template>
            <li  class="file-list__select-file picker" @mousedown="changeFileType(item.filesId)">
              <i class="el-icon-plus"></i>
              <div class="file-list__select-file-title">{{item.name}}</div>
            </li>
          </ul>
        </div>
      </div>
    <table  class="tb1" border="1" style="display: none;">
      <tr><td class="title" >设备指纹</td><td id="gid"></td></tr>
      <tr><td class="title" >设备流水号</td><td id="console"></td></tr>
      <div id="sec1"></div>
      <div id="sec2"></div>
      <tr><td></td><td><button id="test" class="o BR_ATF_ACTION" style="display:none">button</button>
        <button class="loginBtn" onclick="loginHandler()">登录触发</button></td></tr>
    </table>
    <input type="hidden" id="br_gid">
      <div class="step-form__btn-container">
        <button v-if="this.$route.query.yanse == 1" class="step-form__btn-prev2"  @click="goBack">上一步</button>
        <button v-if="this.$route.query.yanse == 1" class="step-form__btn-next2"  @click="goNext" >下一步</button>
        <button v-if="this.$route.query.yanse == 2" class="step-form__btn-prev"  @click="goBack">上一步</button>
        <button v-if="this.$route.query.yanse == 2" class="step-form__btn-next"  @click="goNext">下一步</button>
      </div>
    </div>
    <el-dialog class="file-preview-modal" title="图片预览" :visible="filePreview.show" :before-close="hidePreviewImage"
               :close-on-click-modal="false">
      <div class="file-preview-modal__body">
        <img :src="filePreview.src" alt="图片预览">
      </div>
      <div slot="footer" class="dialog__footer">
        <button class="dialog__footer__confirm-btn" @click="hidePreviewImage">确定</button>
      </div>
    </el-dialog>

    <el-dialog class="progressDialog" title=" " :visible.sync="isShowProgress" size="tiny" top="20%" :show-close="false">
      <el-progress class="upload_progress" :text-inside="true" :stroke-width="18" :percentage="progress"></el-progress>
    </el-dialog>
  </section>
</template>
<script>
  import _ from 'lodash';
  import { mapGetters, mapActions } from 'vuex';
  import * as types from '../../vuex/types/type';
  import 'webuploader/css/webuploader.css';
  import Webuploader from 'webuploader';
  import applyloanApi from '../../api/applyloan/applyloan';

  export default {
    data () {
      return {
        fileTypeLists: {
          itemFiles: []
        },
        fileLists: {
          itemFiles: []
        },
        progress: 0,
        isShowProgress: false,
        screenHeight: document.body.clientHeight,
        uploader: null,
        fileTypeId: '',
        filePreview: {
          show: false,
          src: ''
        }
      };
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        userInfo: types.GET_USER,
      })
    },
    methods: {
      ...mapActions({
        getFileList: types.SET_UPLOAD_FILE_DATA,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),

//      删除附件
      deleteUploadedFile (typeId, file) {
        if (file.uploaderId) {
          this.uploader.removeFile(file.uploaderId, true);
        }
        const param = {
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          filesId: typeId,
          fileId: file.fileId
        };
        applyloanApi.delItemFile(param).then((res) => {
          if (res.rspcode === 1) {
            const typeIndex = _.findIndex(this.fileLists.itemFiles, item => item.filesId === typeId);
            const fileIndex = _.findIndex(this.fileLists.itemFiles[typeIndex].idsarr, item => item.fileId === file.fileId);
            this.fileLists.itemFiles[typeIndex].idsarr.splice(fileIndex, 1);
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        }).catch((error) => {
          this.setFailMessage({
            show: true,
            content: res.rspdesc || '数据获取失败'
          });
        });
      },
      showPreviewImage (fileId, isImage) {
        const src = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${this.userInfo.token}`;
        if (isImage) {
          this.filePreview = {
            show: true,
            src
          };
        } else {
          window.open(`${location.origin}${src}`);
        }
      },
      hidePreviewImage () {
        this.filePreview.show = false;
      },

      goBack () {
        this.uploader.reset();
        this.$router.push({
          name: "step3_bl",
          params: this.$route.params,
          query: this.$route.query
      });
      },
      goNext () {
        const param = {
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: this.$route.query.frontApplyId
        };
        applyloanApi.checkApply(param).then((res) => {
          if (res.code === 1) {
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/Step5_bl`,
                query: {
                  frontApplyId: this.$route.query.frontApplyId,
                  yanse: this.$route.query.yanse,
                  productName: this.$route.query.productName
                }
              });
          } else {
            this.setFailMessage({
              show: true,
              content: res.result || '数据获取失败'
            });
          }
        }).catch((error) => {
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
      },
      changeFileType (fileTypeId) {
        this.fileTypeId = fileTypeId;
        this.uploader.upload();
      },
      uploadBeforeSend (obj, data) {
        data.fileTypeId = this.fileTypeId;
        data.tokenId = this.userInfo.token;
        this.isShowProgress = true;
      },
      uploadProgress (file, percent) {
        const _this = this;
        _this.progress = percent * 100;
      },
      uploadSuccess (file, res) {
        const arr = _.split(res, ':');
        const param = {
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: this.$route.query.frontApplyId,
          filesId: Number(arr[2].replace('fileTypeId=', '')),
          fileId: Number(arr[0].replace('sysFile=', '')),
          fileName: file.name
        };
        applyloanApi.saveItemFiles(param).then((res) => {
          if (res.rspcode === 1) {
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        }).catch((error) => {
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });

        const newFile = {
          typeId: Number(arr[2].replace('fileTypeId=', '')),
          file: {
            fileId: Number(arr[0].replace('sysFile=', '')),
            fileName: file.name,
            uploaderId: file.id
          }
        };
        const typeIndex = _.findIndex(this.fileLists.itemFiles, item => item.filesId === newFile.typeId);
        this.fileLists.itemFiles[typeIndex].idsarr.push(newFile.file);
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadError (file, reason) {
        if (reason === 'http') {
          this.setFailMessage({
            show: true,
            content: '上传出错！请更新浏览器到最新版本或使用谷歌浏览器上传！'
          });
        }
        this.uploader.removeFile(file, true);
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadValidata (type) {
        switch (type) {
          case 'F_DUPLICATE':
            this.setFailMessage({
              show: true,
              content: '该文件您已经上传过了，请不要重复上传！'
            });
            break;
          case 'Q_TYPE_DENIED':
            this.setFailMessage({
              show: true,
              content: '请上传后缀为.jpg，.gif，.bmp，.gif，.doc，.rar，.zip，.7z的文件'
            });
            break;
          case 'Q_EXCEED_SIZE_LIMIT':
            this.setFailMessage({
              show: true,
              content: '请上传大小不超过10M的文件'
            });
            break;
        }
      },
      createWebUploader () {
        this.uploader = Webuploader.create({
          auto: true, // 自动上传
          swf: './static/Uploader.swf',
          server: `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/saveFile.ht`,
          pick: {
            id: '.picker',
            multiple: true
          },
          chunked: true,
          duplicate: false, // 去重
          fileSizeLimit: 1024 * 1024 * 10,
         /* accept: {
            title: '*',
            extensions: 'gif,jpg,jpeg,bmp,png,doc,pdf,rar,zip',
            mimeTypes: 'image/!*,application/msword,application/pdf,application/x-rar-compressed,application/x-zip-compressed,application/x-7z-compressed'
          }*/
        });
        this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
        this.uploader.on('uploadProgress', this.uploadProgress);
        this.uploader.on('uploadSuccess', this.uploadSuccess);
        this.uploader.on('uploadError', this.uploadError);
        this.uploader.on('error', this.uploadValidata);
      },

      goItemFilesPage () {
        const param = {
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: this.$route.query.frontApplyId
        };
        applyloanApi.goItemFilesPage(param).then((res) => {
          if (res.rspcode === 1) {
            this.fileTypeLists = res.data;
            this.fileLists = res.data;
            setTimeout(() => {
            this.createWebUploader();
            this.uploader.refresh();
              }, 1000);
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        }).catch((error) => {
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
      }
    },
    activated () {
      this.getFileList({
        router: this.$router,
        token: this.userInfo.token,
        id: this.$route.query.frontApplyId
      });
    },
    mounted () {
      this.$store.commit('changeActive', 4);
      this.goItemFilesPage();
    }
  };
</script>
<style lang="scss">
  @import "../../styles/fileUpload";

  body{
    overflow: auto!important;
  }

  .step4-form .step-form__title {
    margin-bottom: 36px;
  }

  .file-preview-modal {
    .dialog__footer__confirm-btn {
      background-color: #EB662B;
    }
  }

  .file-preview-modal__body {
    overflow: auto;
  }
  .progressDialog{
    .el-dialog__header {
      display: none;
    }
    .dialog__close{display: none;}
  }
  .upload_progress{
    width:300px;
    margin:0 auto;
  }
  .step-form__btn-prev {
  background:#FF9F75;
  float: left;
  @include step-form__btn;
}
  .step-form__btn-next {
  background:#EB662B;
  float: right;
  @include step-form__btn;
}
 .step-form__btn-prev2 {
  background:#75BC42;
  float: left;
  @include step-form__btn;
}
  .step-form__btn-next2 {
  background:#36A444;
  float: right;
  @include step-form__btn;
}
.step-form__btn-container {
  @include clear;
}
</style>



// WEBPACK FOOTER //
// Step4.vue?b67ba972